import { createNormalizeCheckingNumber } from 'src/utils/create-normalize-checking-number';

export const checkPrice = createNormalizeCheckingNumber(
  `Price argument is not a number. Tabby widget will be use a default price value ${100}`,
  100
);
